import { render } from "./TransactionsPage.vue?vue&type=template&id=e62a96fc"
import script from "./TransactionsPage.vue?vue&type=script&lang=js"
export * from "./TransactionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__